import { render, staticRenderFns } from "./DetalleCalendario.vue?vue&type=template&id=05f4bf2c&scoped=true"
import script from "./DetalleCalendario.vue?vue&type=script&lang=js"
export * from "./DetalleCalendario.vue?vue&type=script&lang=js"
import style0 from "./DetalleCalendario.vue?vue&type=style&index=0&id=05f4bf2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f4bf2c",
  null
  
)

export default component.exports